<template>
  <div>
    <van-dialog v-model="showCont" class="contract" width="97%" style="height: 80%;overflow: scroll;" title="选择合同" :beforeClose="beforeClose" :showConfirmButton = 'false' :close-on-click-overlay="true">
      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入合同名称搜索"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <van-list class="van-list" v-model="loading" style="height: 80%" :finished="finished" finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
        <van-cell v-for="(item,index) in list" :key="index" @click="selectCont(item)">
          <div class="flex-between">
            <div>
              <div class="contractName-wrap"> <div class="contractName"> {{ item.contractName }} </div> </div>
              <div>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.templateType">{{ formatHandel('templateType',item.templateType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.payType">{{ formatHandel('payType',item.payType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.frameType">{{ formatHandel('frameType',item.frameType) }}</van-tag>
                <van-tag color="#999" plain type="primary" v-if="item.custSource">{{ formatHandel('custSource',item.custSource) }}</van-tag>
              </div>
              <div style="color: #666; font-size: 12px">合同金额：{{item.contractMoney || '-'}}</div>
              <div style="color: #999; font-size: 12px">执行时间：{{item.startTime}}-{{item.endTime}}</div>
            </div>
          </div>
        </van-cell>
      </van-list>
      <empty-component v-if="isEmpty" />
    </van-dialog>
  </div>
</template>

<script>
// import { listCont } from '@/api/scrm/mycontract'
import newContract from '@/api/cont/newContract'
import { getDicts } from '@/api/system/dict/data'
import EmptyComponent from '@/components/common/Empty'
export default {
  name: 'SelectContract',
  components: {
    EmptyComponent
  },
  props: {
    show: Boolean
  },
  watch: {
    show: {
      handler(val, oldVal) {
        this.showCont = val
      }
    }
  },
  data() {
    return {
      showCont: false,
      isEmpty: false,
      loading: false,
      finished: false,
      total: 0,
      searchValue: '',
      list: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractStatus: 6,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      form: {},
      options: {
        // 客户类型字典
        templateTypeOptions: [],
        // 客户来源字典
        frameTypeOptions: [],
        // 客户状态
        payTypeOptions: [],
        contractStatusOptions: [],
        custSourceOptions: []
      }
    }
  },
  async created() {
    // 合同模板
    await getDicts('template_type').then(res => {
      this.options.templateTypeOptions = res.data
    })
    // 框架类型
    await getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 垫款方式
    await getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    // 合同状态
    await getDicts('contract_status').then(res => {
      this.options.contractStatusOptions = res.data
    })
    //
    await getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
  },
  mounted() {
    this.init()
    this.handleList()
  },
  methods: {
    async init() {
      document.title = '我的合同'
    },
    QueryReset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        contractStatus: 6,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    },
    // 搜索子组件传递过来的搜索关键字
    onSearch() {
      this.isEmpty = false
      this.QueryReset()
      this.queryParams.contractName = this.searchValue
      this.queryContList()
    },
    // // 过滤子组件传递过来的搜索对象
    // handleFqueryFilter(data) {
    //   this.isEmpty = false;
    //   let query = this.queryParams;
    //   this.queryParams = { ...query, ...data }
    //   this.queryContList()
    // },
    queryContList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleList()
    },
    async handleList() {
      this.loading = true
      const res = await newContract.listPayment(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.list = this.list.concat(...res.rows)
        console.log(this.list)
        this.total = res.total
        this.queryParams.pageNum += 1
        this.loading = false
        this.finished = this.list.length >= res.total
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    selectCont(item) {
      this.form.contractId = item.contractId
      this.form.contractName = item.contractName
      this.form.contractNum = item.contractNum
      this.form.companyName = item.companyName
      this.form.custSource = item.custSource
      this.form.custName = item.custName
      this.showCont = false
      this.$emit('beforeClose', this.form)
    },
    beforeClose() {
      // console.log(this.form)
      this.$emit('handleCancel')
    },
    onLoad() {
      this.handleList()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-list{
  margin-top: -120px;
}
.contract /deep/.van-dialog__content {
  height: 80%;
}
</style>
